export default __webpack_public_path__ + "static/media/ieee-cs-logo.5e75a084.png";